import { render, staticRenderFns } from "./ChartsLab.vue?vue&type=template&id=61efc1e3&"
import script from "./ChartsLab.vue?vue&type=script&lang=js&"
export * from "./ChartsLab.vue?vue&type=script&lang=js&"
import style0 from "./ChartsLab.vue?vue&type=style&index=0&id=61efc1e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports